/**
 * import styles from node_modules
 */

/**
 * semantic-ui-css
 *
 * only import necessary files
 * see https://github.com/Semantic-Org/Semantic-UI/blob/master/src/semantic.less
 *  for order and available files
 */
/* Global */
import 'semantic-ui-css/components/reset.css';
import 'semantic-ui-css/components/site.css';

/* Elements */
import 'semantic-ui-css/components/button.css';
// import 'semantic-ui-css/components/container.css';
import 'semantic-ui-css/components/divider.css';
// import 'semantic-ui-css/components/flag.css';
// import 'semantic-ui-css/components/header.css';
import 'semantic-ui-css/components/icon.css';
// import 'semantic-ui-css/components/image.css';
import 'semantic-ui-css/components/input.css';
import 'semantic-ui-css/components/label.css';
// import 'semantic-ui-css/components/list.css';
import 'semantic-ui-css/components/loader.css';
// import 'semantic-ui-css/components/rail.css';
import 'semantic-ui-css/components/reveal.css';
import 'semantic-ui-css/components/segment.css';
// import 'semantic-ui-css/components/step.css';

/* Collections */
// import 'semantic-ui-css/components/breadcrumb.css';
import 'semantic-ui-css/components/form.css';
// import 'semantic-ui-css/components/grid.css';
import 'semantic-ui-css/components/menu.css';
import 'semantic-ui-css/components/message.css';
// import 'semantic-ui-css/components/table.css';

/* Views */
// import 'semantic-ui-css/components/ad.css';
// import 'semantic-ui-css/components/card.css';
// import 'semantic-ui-css/components/comment.css';
// import 'semantic-ui-css/components/feed.css';
// import 'semantic-ui-css/components/item.css';
// import 'semantic-ui-css/components/statistic.css';

/* Modules */
// import 'semantic-ui-css/components/accordion.css';
// import 'semantic-ui-css/components/checkbox.css';
import 'semantic-ui-css/components/dimmer.css';
import 'semantic-ui-css/components/dropdown.css';
// import 'semantic-ui-css/components/embed.css';
import 'semantic-ui-css/components/modal.css';
// import 'semantic-ui-css/components/nag.css';
// import 'semantic-ui-css/components/popup.css';
// import 'semantic-ui-css/components/progress.css';
// import 'semantic-ui-css/components/rating.css';
// import 'semantic-ui-css/components/search.css';
// import 'semantic-ui-css/components/shape.css';
import 'semantic-ui-css/components/sidebar.css';
// import 'semantic-ui-css/components/sticky.css';
// import 'semantic-ui-css/components/tab.css';
import 'semantic-ui-css/components/transition.css';

// import 'semantic-ui-css/semantic.css';



// WEBPACK FOOTER //
// ./src/semantic-ui-styles.js